/**
 * Render a single list item indicating an empty dropdown state. This
 * appends an `li` with an appropriate class and text to the provided
 * `ul` element.
 *
 * @param dropdownUl - The `ul` element to append the empty state into.
 */
export const renderListEmpty = (dropdownUl: HTMLUListElement) => {
  const noItems = document.createElement("li");
  noItems.classList.add("aiev3-drop-no-items");
  noItems.textContent = "No items found";
  dropdownUl.appendChild(noItems);
};
